// dependencies
import { Map } from "immutable";

const initialState = Map({
	data: Map(),
});

export default function dashboard(state = initialState, action) {
	switch (action.type) {
		// case 'DASHBOARD:DATA@SUCCESS': {
		//     return state.setIn(['data'], action.response.get('data', Map()));
		// }

		default: {
			// never forget your default return state!
			return state;
		}
	}
}
